import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelDynamic as _vModelDynamic, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelText as _vModelText, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "easy-donation-box"
}
const _hoisted_2 = { class: "single-credit-cardd" }
const _hoisted_3 = { class: "wpcm-row wpmc-justify-content-center" }
const _hoisted_4 = { class: "textfield" }
const _hoisted_5 = ["type", "id", "name", "placeholder", "required", "disabled", "onUpdate:modelValue"]
const _hoisted_6 = {
  key: 1,
  class: "wpcm-col-md-12"
}
const _hoisted_7 = { class: "textfield" }
const _hoisted_8 = ["id", "name", "placeholder", "required", "disabled", "onUpdate:modelValue"]
const _hoisted_9 = {
  key: 2,
  class: "wpcm-col-md-12"
}
const _hoisted_10 = { class: "textfield" }
const _hoisted_11 = {
  key: 3,
  class: "wpcm-col-md-12"
}
const _hoisted_12 = { class: "textfield" }
const _hoisted_13 = {
  key: 4,
  class: "wpcm-col-md-12 wpcm-anonymous-field"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!

  return ($setup.useFormBuilder && $setup.displayFields.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.displayFields, (field) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: field.id
              }, [
                _createCommentVNode(" Text Input Fields "),
                (['text', 'email', 'tel'].includes(field.type))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass($setup.getFieldColumnClass(field))
                    }, [
                      _createElementVNode("div", _hoisted_4, [
                        _withDirectives(_createElementVNode("input", {
                          type: field.type,
                          id: field.name,
                          name: field.name,
                          placeholder: field.placeholder || field.label,
                          required: field.required,
                          disabled: $setup.store.loading,
                          "onUpdate:modelValue": ($event: any) => (($setup.store.billing_fields[$setup.getStoreKey(field)]) = $event)
                        }, null, 8 /* PROPS */, _hoisted_5), [
                          [_vModelDynamic, $setup.store.billing_fields[$setup.getStoreKey(field)]]
                        ])
                      ])
                    ], 2 /* CLASS */))
                  : _createCommentVNode("v-if", true),
                _createCommentVNode(" Textarea Field "),
                (field.type === 'textarea')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _withDirectives(_createElementVNode("textarea", {
                          id: field.name,
                          name: field.name,
                          placeholder: field.placeholder || field.label,
                          required: field.required,
                          disabled: $setup.store.loading,
                          rows: "4",
                          "onUpdate:modelValue": ($event: any) => (($setup.store.billing_fields[$setup.getStoreKey(field)]) = $event)
                        }, null, 8 /* PROPS */, _hoisted_8), [
                          [_vModelText, $setup.store.billing_fields[$setup.getStoreKey(field)]]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                _createCommentVNode(" Select Field "),
                (field.type === 'select')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_el_select, {
                          id: field.name,
                          name: field.name,
                          placeholder: field.placeholder || 'Please select...',
                          required: field.required,
                          disabled: $setup.store.loading,
                          filterable: "",
                          "model-value": $setup.store.billing_fields[$setup.getStoreKey(field)],
                          "onUpdate:modelValue": ($event: any) => ($setup.setStoreFieldValue(field, $event)),
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.options || [], (option) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: option.value,
                                label: option.label,
                                value: option.value
                              }, null, 8 /* PROPS */, ["label", "value"]))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id", "name", "placeholder", "required", "disabled", "model-value", "onUpdate:modelValue"])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                _createCommentVNode(" Checkbox Field "),
                (field.type === 'checkbox')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_el_checkbox, {
                          id: field.name,
                          name: field.name,
                          required: field.required,
                          disabled: $setup.store.loading,
                          modelValue: $setup.store.billing_fields[$setup.getStoreKey(field)],
                          "onUpdate:modelValue": ($event: any) => (($setup.store.billing_fields[$setup.getStoreKey(field)]) = $event)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(field.label), 1 /* TEXT */)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id", "name", "required", "disabled", "modelValue", "onUpdate:modelValue"])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                _createCommentVNode(" Anonymous Donation Field "),
                (field.type === 'anonymous_donation')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createVNode(_component_el_checkbox, {
                        id: "anonymous_donation",
                        name: "anonymous_donation",
                        disabled: $setup.store.loading,
                        modelValue: $setup.store.billing_fields.anonymous_donation,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.store.billing_fields.anonymous_donation) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(field.label || $props.strings?.anonymous_donation || 'Make this donation anonymous'), 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["disabled", "modelValue"])
                    ]))
                  : _createCommentVNode("v-if", true)
              ], 64 /* STABLE_FRAGMENT */))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}